import {
  JuridictionAdminResponseDto,
  JuridictionResponseDto,
  JuridictionResponseDtoTypeEnum,
  ReferentielSearchResultDtoJuridictionAdminResponseDto,
  SearchJuridictionUsingSpecsUsingGETQueryParams,
} from 'lib_api/lib/api/gen';

import { BaseOptionType } from 'components/BaseForm/Select/BaseSelect';
import {
  FetchDataResult,
  TablePagination,
  TableSort,
} from 'components/WrappedComponents/Table/types';
import { JuridictionSort } from 'enums/referentiels/Juridiction';
import { useApi } from 'hooks/ApiStoreContext';
import { getStringOrThrow } from 'typeGuards/typeGuards';

export type FilterDashboardJuridiction = {
  idCorrelation?: string;
  origineElement?: string;
  numero?: string;
  type?: JuridictionResponseDtoTypeEnum;
  libelle?: string;
  idCorrelationJuridictionParentes?: BaseOptionType<JuridictionResponseDto>[];
  codePostal?: string;
  valid?: boolean;
};

export function useSearchJuridictionQuery(
  filters: FilterDashboardJuridiction,
  sort: TableSort<JuridictionSort>,
  pagination?: TablePagination,
): [
  () => Promise<ReferentielSearchResultDtoJuridictionAdminResponseDto>,
  (
    result: ReferentielSearchResultDtoJuridictionAdminResponseDto,
  ) => FetchDataResult<JuridictionAdminResponseDto>,
] {
  const controllerApi = useApi().ReferentielControllerApi;

  const fetchData =
    (): Promise<ReferentielSearchResultDtoJuridictionAdminResponseDto> => {
      const request: SearchJuridictionUsingSpecsUsingGETQueryParams = {
        filters: {
          ...filters,
          idCorrelationJuridictionParentes:
            filters.idCorrelationJuridictionParentes?.map(option =>
              getStringOrThrow(option.value),
            ),
          ...pagination,
        },
        sorts: {
          codePostal: sort?.CODE_POSTAL,
          libelle: sort?.LIBELLE,
          numero: sort?.NUMERO,
          origineElement: sort?.ORIGINE_ELEMENT,
          type: sort?.TYPE,
          valid: sort?.VALID,
        },
      };

      return controllerApi.searchJuridictionUsingSpecsUsingGET(request);
    };

  const convertToFetchData = (
    searchResult: ReferentielSearchResultDtoJuridictionAdminResponseDto,
  ): FetchDataResult<JuridictionAdminResponseDto> => {
    return {
      data: searchResult.results.referenceDtoList,
      total: searchResult.total,
    };
  };

  return [fetchData, convertToFetchData];
}
